import { InvoicesSearchType } from 'b2b-common/core/account/api/invoices';
import {
  CLEAR_INVOICES_SEARCH,
  INVOICES_SEARCH,
  INVOICES_SEARCH_FULFILLED,
  INVOICES_SEARCH_REJECTED,
} from './actionTypes';
import {
  ClearInvoicesSearchAction,
  InvoicesSearchAction,
  InvoicesSearchFulfilledAction,
  InvoicesSearchRejectedAction,
} from './types';

const invoicesSearch = (searchQuery: string): InvoicesSearchAction => ({
  type: INVOICES_SEARCH,
  payload: {
    searchQuery,
  },
});

const invoicesSearchFulfilled = (response: InvoicesSearchType): InvoicesSearchFulfilledAction => ({
  type: INVOICES_SEARCH_FULFILLED,
  payload: {
    data: response,
  },
});

const invoicesSearchRejected = (error: ErrorType): InvoicesSearchRejectedAction => ({
  type: INVOICES_SEARCH_REJECTED,
  payload: {
    error,
  },
});

const clearInvoicesSearch = (): ClearInvoicesSearchAction => ({
  type: CLEAR_INVOICES_SEARCH,
});

export {
  clearInvoicesSearch,
  invoicesSearch,
  invoicesSearchFulfilled,
  invoicesSearchRejected,
};
